import { money, pct } from './format.js';

// Account by account, so the planner can tick each one off against the paper in
// front of them. The weight column is the useful one: a statement that lists
// its own percentages and does not reach 100 is telling you a position was
// missed. Planner-facing, never printed.

export default function AccountReconciliation({ accounts }) {
  if (!accounts || !accounts.length) return null;

  const shortByWeight = accounts.filter(a => a.weightComplete === false);

  return (
    <div className="asmt-review-block">
      <div className="asmt-review-subhead">Account by account</div>
      <table className="asmt-table">
        <thead>
          <tr>
            <th>Account</th>
            <th>As of</th>
            <th className="num">Positions</th>
            <th className="num">Value</th>
            <th className="num">Weights add to</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((a, i) => (
            <tr key={`${a.account}-${i}`} className={a.weightComplete === false ? 'is-flagged' : undefined}>
              <td>{a.account}</td>
              <td>{a.asOf || <span className="asmt-muted">not stated</span>}</td>
              <td className="num">{a.positions || <span className="asmt-muted">-</span>}</td>
              <td className="num">{money(a.value)}</td>
              <td className="num">
                {a.weightSumPct === null
                  ? <span className="asmt-muted">not stated</span>
                  : pct(a.weightSumPct, 1)}
                {a.weightComplete === false && <span className="asmt-flag">check</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {shortByWeight.length > 0 && (
        <p className="asmt-review-note">
          The statement's own percentages do not add to 100 in{' '}
          {shortByWeight.length === 1
            ? shortByWeight[0].account
            : `${shortByWeight.length} of these accounts`}
          , which usually means a position was missed. Read{' '}
          {shortByWeight.length === 1 ? 'that account' : 'those accounts'} line by line against the
          statement before this goes out.
        </p>
      )}
    </div>
  );
}
